export default {
  a0: 'アップラインを紐付ける',
  a1: 'アップラインのアドレスを入力してください',
  a2: '送信',
  a3: 'Binance Smart Chainを使用してください',
  a4: '有効なウォレットアドレスを入力してください',
  a5: 'オンチェーンでの承認待ち',
  a6: '紐付け完了',
  a7: '操作に失敗しました',
  a8: 'NX流動性',
  a9: '報酬プール',
  b0: 'サポートプール',
  b1: 'ノードに参加する',
  b2: 'ノード参加処理中',
  b3: '参加済み',
  b4: '今すぐ参加',
  b5: '参加期間終了',
  b6: 'ステーキング',
  b7: '参加額',
  b8: '現在の残高',
  b9: '金額を入力してください',
  c0: 'ノード参加費用',
  c1: 'キャンセル',
  c2: '確認',
  c3: 'ブロックチェーンの承認処理中',
  c4: 'ステーキング成功',
  c5: 'ステーキング完了',
  c6: 'ステーキング期間（日数）',
  c7: 'ステーキング額',
  c8: '日次利回り',
  c9: '残高不足',
  d0: '参加成功',
  d1: '有効な参加額を入力してください',
  d2: '利用可能残高不足',
  d3: '参加期間外',
  d4: 'ガス代不足',
  d5: '注文総数',
  d6: '合計金額',
  d7: '処理中',
  d8: '償還待ち',
  d9: '完了',
  e0: 'ステーキング額',
  e1: '収益',
  e2: 'ステーキングの償還',
  e3: 'データなし',
  e4: '読み込み中',
  e5: '償還済み',
  e6: 'ホーム',
  e7: 'ステーキング記録',
  e8: 'マイページ',
  e9: 'NFT獲得方法A',
  f0: '合計{num}人のノードユーザーを招待して、NFTを受け取りましょう',
  f1: '招待する追加のノードユーザー数',
  f2: '',
  f3: 'NFT獲得方法B',
  f4: '「V5」ステータスに到達して、NFTを受け取りましょう',
  f5: '小規模チームの業績差',
  f6: '自分のNFT',
  f7: 'ID',
  f8: '転送',
  f9: 'NFTを転送',
  g0: '転送先アドレスを入力してください',
  g1: '有効な転送先アドレスを入力してください',
  g2: '転送済み',
  g3: 'はグローバルな予測プラットフォームです',
  g4: 'NXを取引',
  g5: '未対応',
  g6: 'CHENXIANGエコシステム',
  g7: 'チームボーナス額',
  g8: '獲得収益',
  g9: '詳細を表示',
  h0: '現在のランク',
  h1: 'ノードユーザー',
  h2: 'アクティブユーザー',
  h3: '次のランクまでの進捗',
  h4: '必要なチーム実績',
  h5: '自分のコミュニティ',
  h6: '招待リンク',
  h7: 'コピー',
  h8: 'アップライン',
  h9: '個人実績',
  i0: 'チーム実績',
  i1: 'コピーしました',
  i2: 'コピーに失敗しました',
  i3: '収益履歴',
  i4: 'ノード紹介',
  i5: 'ステーキング収益',
  i6: 'チーム収益',
  i7: 'ノードリリース',
  i8: 'ノード配当',
  i9: 'NFT配当',
  j0: '60日間ステーキング報酬',
  j1: 'もっと見る',
  j2: 'ステーキング報酬',
  j3: '権限がありません',
  j4: 'チームの総合パフォーマンス',
  j5: 'チームのアドレス数',
  j6: 'アクティブなチームのアドレス数'
}
